import ga from "@store/Framework/Common/GoogleAnalytics";

const getItemsValue = (items: Toolkit.GoogleAnalytics.Event["items"], options?: Toolkit.GoogleAnalytics.Options) => {
    if (!items) {
        return undefined;
    }

    return ga.util.parseAmount(
        items.reduce((result, { price, quantity }) => {
            if (!price || !quantity) {
                return result;
            }

            return result + price * quantity;
        }, 0),
    );
};

export default getItemsValue;
